import * as React from "react";
import type { SVGProps } from "react";

interface AceProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Ace = ({ cancelled = false, ...props }: AceProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M12 .75C5.787.75.75 5.787.75 12S5.787 23.25 12 23.25 23.25 18.213 23.25 12 18.213.75 12 .75"
      />
      <path
        fill="#000"
        d="M12 1.7C6.311 1.7 1.7 6.311 1.7 12S6.311 22.3 12 22.3 22.3 17.689 22.3 12 17.689 1.7 12 1.7M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
      />
      <path
        fill="#60B100"
        d="M8.014 17.4q-.512 0-.712-.304t-.008-.832l3.488-9.28q.288-.784 1.136-.784h.144q.848 0 1.136.784l3.488 9.28q.192.529-.008.832-.2.304-.728.304h-.336q-.848 0-1.12-.816l-.48-1.408H9.902l-.48 1.408q-.255.816-1.12.816zm2.56-4.144h2.784l-1.376-4.064z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Ace;
